export const UNPLUGGED = 0;
export const CHARGING = 1;
export const CHARGED = 2;
export const READY_TO_USE = 3;
export const CLEANING = 4;
export const UNCHARGED = 5;
